import { render, staticRenderFns } from "./EditAppSetting.vue?vue&type=template&id=22517c0a&"
import script from "./EditAppSetting.vue?vue&type=script&lang=js&"
export * from "./EditAppSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports